import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { Card, CardHeader, CardContent, Divider, Button } from '@material-ui/core';
import { GridList, GridListTile } from '@material-ui/core';
import AddPhotoIcon from '@material-ui/icons/AddToPhotos';
import EditIcon from '@material-ui/icons/Edit';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import ClearIcon from '@material-ui/icons/Clear'

import LightBoxImage from './LightBoxImage';
import { AttachFile, CameraAlt, CloseRounded, RadioButtonUnchecked } from '@material-ui/icons';

const useStyles = makeStyles(theme => ({
    divider: {
        marginRight: theme.spacing(1),
        marginLeft: theme.spacing(1)
    }
}));

const PhotoGalleryCard = ({ addFile, images, deletePhoto }) => {
    const classes = useStyles();
    const [openImages, setOpenImages] = React.useState(false);
    const [currentPhoto, setCurrentPhoto] = React.useState(0);
    const [photosEditable, setPhotosEditable] = React.useState(false)
    const [showCamera, setShowCamera] = React.useState(false)
    const [dragOver, setDragOver] = useState(false)

    const isMobileDevice = (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);

    const addFiles = files => {
        addFile(files);
    }

    const getData = () => {
        let data = [];

        if (!images) return data;

        images.forEach(value => {
            const { url, name } = value;

            data.push({ img: url, title: name });
        });

        return data;
    }

    const getDataForLightBox = () => {
        let data = [];

        if (!images) return data;

        images.forEach(value => {
            data.push(value.url);
        });

        return data;
    }

    const show = async () => {
        setShowCamera(true)

        let video = document.querySelector("#video-edu");

        let stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: false });
        video.srcObject = stream;
    }

    const addPhotoCamera = () => {
        const video = document.querySelector("#video-edu");
        const canvas = document.querySelector("#canvas-edu");

        canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);
        const data = canvas.toDataURL('image/jpeg');

        const file = { name: 'CameraPhoto', data, type: 'camera' }

        addFile([file])
    }

    const onDropFiles = (evt) => {
        evt.preventDefault()
        const files = evt.dataTransfer.files;
        addFiles(files)
        setDragOver(false)
    }

    return (
        <div>
            <div style={{ display: showCamera ? 'initial' : 'none' }}>
                <div style={{ position: 'fixed', top: '80px', left: '200px', display: 'flex', flexDirection: 'column', height: '800px', width: '700px', backgroundColor: 'black', zIndex: 99 }}>
                    <div style={{ height: '80px', display: 'flex', flexDirection: 'row-reverse', alignItems: 'center' }}>
                        <Button onClick={() => setShowCamera(false)}>
                            <CloseRounded style={{ fontSize: '60px', color: 'white' }} />
                        </Button>
                    </div>
                    <video id="video-edu" width="700" height="720" autoPlay></video>
                    <div style={{ height: '100px', display: 'flex', justifyContent: 'center', alignItems: 'center', borderTop: '1px solid white' }}>
                        <Button><RadioButtonUnchecked onClick={addPhotoCamera} style={{ fontSize: '80px', color: 'white' }} /></Button>
                    </div>
                </div>
                <canvas id="canvas-edu" style={{ position: 'fixed', top: '80px', left: '200px', display: 'flex', flexDirection: 'column', height: '800px', width: '700px', backgroundColor: 'black' }}></canvas>
            </div>
            <Card>
                <CardHeader
                    title="Fotos"
                    action={
                        <div>
                            {!isMobileDevice && <Button id="start-camera" onClick={show}>
                                <CameraAlt color="primary" />
                            </Button>}
                            <label htmlFor="raised-button-file">
                                <input
                                    accept="image/*"
                                    style={{ display: 'none' }}
                                    id="raised-button-file"
                                    multiple
                                    type="file"
                                    onChange={e => addFiles(e.target.files)}
                                />
                                <Button variant="text" component="span">
                                    <AddPhotoIcon color='primary' />
                                </Button>
                            </label>
                            <Button variant="text" component="span" onClick={() => setPhotosEditable(!photosEditable)}>
                                {!photosEditable
                                    ? <EditIcon color='primary' />
                                    : <ClearIcon color="primary" />
                                }
                            </Button>
                        </div>
                    }>
                </CardHeader>
                <Divider className={classes.divider}></Divider>
                <CardContent>
                    <div class="drag"
                        style={{ width: '100%', display: 'flex' }}
                        onDrop={onDropFiles}
                        onDragOver={e => {
                            e.preventDefault()
                            e.stopPropagation()
                        }}
                        onDragEnter={e => {
                            e.preventDefault()
                            e.stopPropagation()
                            setDragOver(true)
                        }}
                        onDragLeave={e => {
                            setDragOver(false)
                        }}
                    >
                        { !dragOver && <GridList cellHeight={160} className={classes.gridList} cols={3}>
                            {getData().map((tile, index) => (
                                <GridListTile key={tile.img} cols={tile.cols || 1}>
                                    <img src={tile.img} alt={tile.title}
                                        onClick={() => {
                                            setCurrentPhoto(index);
                                            setOpenImages(true);
                                        }} />
                                    {
                                        photosEditable &&
                                        <div style={{ position: 'absolute', top: 0, cursor: 'pointer' }}>
                                            <RemoveCircleIcon style={{ color: 'red' }} onClick={() => deletePhoto(index)} />
                                        </div>
                                    }
                                </GridListTile>
                            ))}
                        </GridList> }
                        { (dragOver || getData().length === 0) &&
                            <div style={{ 
                                    width: '100%', 
                                    height: '160px', 
                                    display: 'flex', 
                                    justifyContent: 'center', 
                                    alignItems: 'center',
                                    backgroundColor: dragOver ? 'initial': '#eeeeee',
                                    border: dragOver ? 'dotted' : 'initial'
                                }}
                            >
                                <AttachFile />
                                <span>
                                    Arrastra las fotos...
                                </span>
                            </div>
                        }
                    </div>
                    <LightBoxImage isOpen={openImages} images={getDataForLightBox()} currentPhoto={currentPhoto} onClose={() => setOpenImages(false)}></LightBoxImage>
                </CardContent>
            </Card>
        </div>
    );
};

export default PhotoGalleryCard;